export const suppliers = [
  {
    id: 1,
    name: "ShenZhen ElectroPro Co.",
    category: "Electronics",
    location: "Shenzhen, China",
    rating: 4.9,
    reviews: 1240,
    minOrder: "$500",
    image: "https://public.readdy.ai/ai/img_res/4a48e624778229ba00125c89742dc8bb.jpg",
    verified: true,
    badge: "Gold Supplier",
  },
  {
    id: 2,
    name: "FashionLink Garment Factory",
    category: "Fashion",
    location: "Guangzhou, China",
    rating: 4.8,
    reviews: 876,
    minOrder: "$300",
    image: "https://readdy.ai/api/search-image?query=clothing%20garment%20factory%20with%20sewing%20machines%20and%20fabric%20rolls%2C%20professional%20textile%20manufacturing%2C%20bright%20clean%20workspace%2C%20workers%20in%20uniforms%2C%20modern%20fashion%20production%20facility%2C%20white%20walls&width=400&height=300&seq=sup2&orientation=landscape",
    verified: true,
    badge: "Verified",
  },
  {
    id: 3,
    name: "HomeStyle Furniture Works",
    category: "Home Goods",
    location: "Foshan, China",
    rating: 4.7,
    reviews: 654,
    minOrder: "$800",
    image: "https://readdy.ai/api/search-image?query=modern%20furniture%20factory%20showroom%20with%20wooden%20furniture%20pieces%2C%20clean%20warehouse%20setting%2C%20professional%20manufacturing%20facility%2C%20bright%20lighting%2C%20organized%20production%20floor%2C%20neutral%20background&width=400&height=300&seq=sup3&orientation=landscape",
    verified: true,
    badge: "Top Rated",
  },
  {
    id: 4,
    name: "BeautyGlow Cosmetics Ltd.",
    category: "Beauty",
    location: "Shanghai, China",
    rating: 4.9,
    reviews: 2100,
    minOrder: "$200",
    image: "https://readdy.ai/api/search-image?query=cosmetics%20beauty%20products%20factory%20with%20skincare%20bottles%20and%20packaging%2C%20clean%20white%20laboratory%20setting%2C%20professional%20beauty%20manufacturing%2C%20organized%20production%20line%2C%20bright%20modern%20facility&width=400&height=300&seq=sup4&orientation=landscape",
    verified: true,
    badge: "Gold Supplier",
  },
];

export const supplierCategories = ["All", "Electronics", "Fashion", "Home Goods", "Beauty", "Toys", "Sports"];
